import axios from 'axios';
import config from '../../config/app';

export const getServices = async () => axios({
  method: 'GET',
  baseURL: config.BASE_PATH,
  url: '/api/v1/services',
  headers: {
    'X-PagerDuty-Api-Local': 1
  }
});

export const postService = async (serviceName, escalationPolicyId) => {
  const serviceBody = {
    name: serviceName,
    description: 'Your first service - describe what this service is monitoring '
    + 'and any information that will help responders.\n\n'
    + 'For example: What is the SLA of this service? '
    + 'Where are the runbooks for this service stored? What tier level is this service?',
    escalation_policy: {
      id: escalationPolicyId,
      type: 'escalation_policy_reference'
    },
    alert_creation: 'create_alerts_and_incidents'
  };

  return axios({
    method: 'POST',
    baseURL: config.BASE_PATH,
    url: '/api/v1/services',
    headers: {
      'X-PagerDuty-Api-Local': 1
    },
    data: {
      service: serviceBody
    }
  });
};
